class TestimonialsSlider extends HTMLElement {
  constructor() {
    super();
    this.swiper = null;
    this.cancelVisibility = null;
  }

  connectedCallback() {
    // Swiper measures every slide on init, which is a forced layout. Hold that
    // off until the slider is near the viewport; above-the-fold sliders still
    // initialize on the observer's first callback.
    this.cancelVisibility = window.wakaWhenVisible(this, () => {
      this.cancelVisibility = null;
      this.initSwiper();
    });
  }

  disconnectedCallback() {
    if (this.cancelVisibility) {
      this.cancelVisibility();
      this.cancelVisibility = null;
    }

    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  }

  initSwiper() {
    if (typeof Swiper === 'undefined') {
      console.warn('Swiper JS is not loaded yet.');
      return;
    }

    const swiperContainer = this.querySelector('.swiper');
    if (!swiperContainer) {
      return;
    }

    const slideCount = swiperContainer.querySelectorAll('.swiper-slide').length;
    if (!slideCount) {
      return;
    }

    if (this.swiper) {
      this.swiper.destroy(true, true);
    }

    const offsets = window.getWakaSliderOffsets();
    const offsetMobile = offsets.mobile;
    const offsetLg = offsets.lg;
    const offsetXl = offsets.xl;

    this.swiper = new Swiper(swiperContainer, {
      slidesPerView: 1.15,
      spaceBetween: 20,
      slidesOffsetBefore: offsetMobile,
      slidesOffsetAfter: offsetMobile,
      breakpoints: {
        480: {
          slidesPerView: 1.4,
          spaceBetween: 20,
          slidesOffsetBefore: offsetMobile,
          slidesOffsetAfter: offsetMobile,
        },
        640: {
          slidesPerView: 1.7,
          spaceBetween: 20,
          slidesOffsetBefore: offsetMobile,
          slidesOffsetAfter: offsetMobile,
        },
        768: {
          slidesPerView: 2.2,
          spaceBetween: 20,
          slidesOffsetBefore: offsetMobile,
          slidesOffsetAfter: offsetMobile,
        },
        1024: {
          slidesPerView: 2.6,
          spaceBetween: 20,
          slidesOffsetBefore: offsetLg,
          slidesOffsetAfter: offsetLg,
        },
        1280: {
          slidesPerView: 2.9,
          spaceBetween: 20,
          slidesOffsetBefore: offsetXl,
          slidesOffsetAfter: offsetXl,
        },
        1536: {
          slidesPerView: 3.6,
          spaceBetween: 20,
          slidesOffsetBefore: offsetXl,
          slidesOffsetAfter: offsetXl,
        },
      },
      navigation: {
        nextEl: this.querySelector('.swiper-button-next'),
        prevEl: this.querySelector('.swiper-button-prev'),
      },
    });

    this.toggleControls(slideCount);
  }

  toggleControls(slideCount) {
    const shouldShowControls = slideCount > 1;
    const nextButton = this.querySelector('.swiper-button-next');
    const prevButton = this.querySelector('.swiper-button-prev');

    [nextButton, prevButton].forEach((element) => {
      if (!element) return;
      element.classList.toggle('hidden', !shouldShowControls);
    });

    const section = this.closest('[id^="shopify-section-"]');
    if (section) {
      const headerButtons = section.querySelectorAll(
        '.swiper-button-prev, .swiper-button-next',
      );
      headerButtons.forEach((button) => {
        button.classList.toggle('hidden', !shouldShowControls);
      });
    }
  }
}

if (!customElements.get('testimonials-slider')) {
  customElements.define('testimonials-slider', TestimonialsSlider);
}
